var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ViewChild, Input } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { EscritoPresentarComponent } from '../escrito/escrito-presentar.component';
import { Subscription } from 'rxjs';
import { Message } from '../../common/dialog/mensaje.component';
import { PopupRecaptcha } from '../../common/recaptcha/popup-recaptcha';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { UuidService } from '../../services/uuid.service';
import { UuidActuacionPopupComponent } from '../uuid-actuacion/uuid-actuacion-popup.component';
var form;
var UuidViewComponent = (function () {
    function UuidViewComponent(_comService, _uuidService, router, route) {
        this._comService = _comService;
        this._uuidService = _uuidService;
        this.router = router;
        this.route = route;
        this.subscription = new Subscription();
        this.subscription2 = new Subscription();
        this.mensajeZocalo = "";
        this.mostrarZocalo = false;
        this.verActuaciones = false;
        this.permisoAct = true;
        this.noEsOculto = true;
        this.isCollapsedContent = false;
        this.uuidActivo = false;
        this.instanceId = Math.floor(Math.random() * 1000000);
    }
    UuidViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._comService.emitBlocking(true);
        this.route.params.subscribe(function (params) {
            _this.uuidCod = params['uuidCod'];
            _this.verificarUuid(_this.uuidCod);
        });
    };
    UuidViewComponent.prototype.verificarUuid = function (codigo) {
        var _this = this;
        this._uuidService.findUuid(this.uuidCod).subscribe(function (response) {
            if (response) {
                _this.uuid = response;
                //nivel acceso de expediente
                if (_this.uuid.nivacc === 2) {
                    _this.noEsOculto = false;
                }
                else {
                    _this.noEsOculto = true;
                    _this.mostrarZocalo = false;
                    _this.mensajeZocalo = "";
                }
                _this.uuidActivo = _this.uuid.uuidActivo;
                //busco la actuacion
                _this.getActuacion();
            }
            else {
                _this._comService.emitBlocking(false);
                //no existe el uuid
                _this.router.navigate(['/enlace-no-autorizado']);
            }
        });
    };
    UuidViewComponent.prototype.getActuacion = function () {
        var _this = this;
        this._uuidService.findActuacion(this.uuid.uuidCod).subscribe(function (response) {
            if (response) {
                _this.actuacion = response;
                //verifico el nivel de acceso del expediente y que la lectura de qr este activa
                if (!_this.noEsOculto) {
                    _this.mostrarZocalo = true;
                    _this.mensajeZocalo = "No es posible acceder al contenido de la actuación. El expediente es de carácter Privado.";
                }
                else {
                    if (!_this.uuidActivo) {
                        _this.mostrarZocalo = true;
                        _this.mensajeZocalo = "No es posible acceder al contenido de la actuación. Se ha restringido su visibilidad.";
                    }
                    else {
                        _this.mostrarZocalo = false;
                        _this.mensajeZocalo = "";
                    }
                }
                _this._comService.emitBlocking(false);
            }
            else {
                _this._comService.emitBlocking(false);
                //no existe la actuacion
                _this.router.navigate(['/enlace-no-autorizado']);
            }
        });
    };
    UuidViewComponent.prototype.getStyleAct = function (nav) {
        var classes = "tab-pane";
        if (nav) {
            classes = "nav-link";
        }
        if (this.permisoAct) {
            classes = "active " + classes;
        }
        return classes;
    };
    UuidViewComponent.prototype.openAct = function (id, video) {
        if (this.noEsOculto && this.uuidActivo) {
            this.actPopup.video = video;
            if (video) {
                this.actPopup.expediente = this.uuid.tipo + " " + this.uuid.numero + "/" + this.uuid.anio;
                this.actPopup.caratula = this.uuid.caratula;
            }
            else {
                this.actPopup.loadAct(this.uuid.uuidCod);
            }
        }
    };
    UuidViewComponent.prototype.closePopupAct = function (id) {
        this.actPopup.finalize();
    };
    UuidViewComponent.prototype.getUrlAdjunto = function (id) {
        var _this = this;
        if (this.noEsOculto && this.uuidActivo) {
            var fileName = "adjuntos.zip";
            var ab = document.createElement("a");
            document.body.appendChild(ab);
            this._comService.emitBlocking(true);
            this._uuidService.adjuntosAct(this.uuid.uuidCod).subscribe(function (res) {
                var file = new Blob([res], { type: 'application/zip' });
                var fileURL = window.URL.createObjectURL(file);
                _this._comService.emitBlocking(false);
                ab.href = fileURL;
                ab.download = fileName;
                ab.click();
            }, function (error) {
                _this._comService.emitBlocking(false);
                alert("No se pudo descargar el adjunto");
            });
        }
    };
    return UuidViewComponent;
}());
__decorate([
    ViewChild(EscritoPresentarComponent),
    __metadata("design:type", EscritoPresentarComponent)
], UuidViewComponent.prototype, "escPresentar", void 0);
__decorate([
    ViewChild(UuidActuacionPopupComponent),
    __metadata("design:type", UuidActuacionPopupComponent)
], UuidViewComponent.prototype, "actPopup", void 0);
__decorate([
    ViewChild(PopupRecaptcha),
    __metadata("design:type", PopupRecaptcha)
], UuidViewComponent.prototype, "captchaPopup", void 0);
__decorate([
    ViewChild(Message),
    __metadata("design:type", Message)
], UuidViewComponent.prototype, "msgPopup", void 0);
__decorate([
    ViewChild(Message),
    __metadata("design:type", Message)
], UuidViewComponent.prototype, "msgPopupAct", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], UuidViewComponent.prototype, "expId", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UuidViewComponent.prototype, "mensajeZocalo", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UuidViewComponent.prototype, "mostrarZocalo", void 0);
UuidViewComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'uuid-view',
        templateUrl: 'uuid-view.component.html',
    }),
    __metadata("design:paramtypes", [CommonService,
        UuidService,
        Router,
        ActivatedRoute])
], UuidViewComponent);
export { UuidViewComponent };
//# sourceMappingURL=uuid-view.component.js.map